<template>
  <div class="page-container">
    <div class="home-container">
      <div class="logo-container" :class="{ 'white-bg': showProductList }">
        <div class="logo-wrapper">
          <img src="../assets/logo.png" alt="" class="logo">
        </div>
        <div class="nav-links" :class="{ 'dark-text': showProductList }">
          <div class="nav-item" @click="$router.push('/')">首页</div>
          <div class="nav-item" @click="handleProductClick" :class="{ 'active-nav': showProductList }">
            雾曼技术和产品
          </div>
          <div class="nav-item" @click="$router.push('/Dynamic')">雾曼动态</div>
          <div class="nav-item nav-item2" @click="$router.push('/about'), FisMobile()">关于雾曼</div>
          <div class="nav-item" @click="$router.push('/contact')">联系雾曼</div>
          <div class="nav-item" @click="$router.push('/Cooperation')">成为合伙人</div>
        </div>
        <div class="consult-button" @click="navigateToConsult">需求咨询</div>

        <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="mobile-menu" :class="{ 'show': showMobileMenu }">
          <div class="mobile-menu-item" @click="$router.push('/')">首页</div>
          <!-- <div class="mobile-menu-item" @click="handleProductClick" :class="{ 'active-nav': showProductList }">雾曼技术和产品</div> -->
          <div class="mobile-menu-item" @click="$router.push('/Dynamic')">雾曼动态</div>
          <div class="mobile-menu-item" @click="$router.push('/about')">关于雾曼</div>
          <div class="mobile-menu-item" @click="$router.push('/contact')">联系雾曼</div>
          <div class="mobile-menu-item" @click="$router.push('/Cooperation')">成为合伙人</div>
          <div class="mobile-menu-item highlight" @click="navigateToConsult">需求咨询</div>
        </div>
      </div>
      <product-list v-if="showProductList" :top="0"></product-list>
      <div class="info-container">
        <div class="page-title">关于雾曼</div>
      </div>
    </div>
    <div class="content-section">
      <div class="content-wrapper">
        <div class="left-content">
          <div class="section-heading">关于雾曼</div>
          <div class="intro-text team-content" v-html="wumanIntro"></div>

          <div class="team-section">
            <div class="section-header">
              <div class="red-bar"></div>
              <div class="header-text">团队介绍</div>
            </div>
            <div class="team-content" v-html="teamIntro"></div>
          </div>

          <div class="tech-section">
            <div class="section-header">
              <div class="red-bar"></div>
              <div class="header-text">核心技术</div>
            </div>
            <div class="tech-content" v-html="coreTech"></div>
          </div>

          <div class="platform-section">
            <div class="section-header">
              <div class="red-bar"></div>
              <div class="header-text">我们的平台</div>
            </div>
            <div class="platform-content" v-html="ourPlatform"></div>
          </div>
        </div>
        <div class="right-content">
          <img src="../assets/About/About2.png" alt="">
        </div>
      </div>
    </div>
    <div class="patent-section">
      <div class="patent-container">
        <div class="patent-left">
          <div class="section-title">核心技术专利</div>
          <div class="patent-box">
            <div class="patent-header">
              <div class="patent-icon">
                <img src="../assets/About/About3.png" alt="">
              </div>
              <div class="patent-title">我们发明了伴生雾化技术</div>
            </div>
            <div class="patent-content">
              一种新的雾:气溶胶，低温雾化，不破坏活性，可适配多种药剂(84、次氯酸、生物酶、益生菌等)，形成复合雾--气溶胶，助剂形成轻质分子包裹雾滴，促进雾滴悬浮，减缓雾滴挥发与沉降，雾化颗粒可长时间悬浮于空气中，360°全覆盖不留死角,持久发挥药雾功能(杀菌消毒、杀虫、除臭除味等)。
            </div>
          </div>
          <div class="tech-stats">
            <div class="tech-stats-title">跨界技术：雾化技术上升到新的高度</div>
            <div class="stats-container">
              <div class="stat-item">
                <div class="stat-number">2</div>
                <div class="stat-label">项发明专利</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">5</div>
                <div class="stat-label">项在申请中</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">12</div>
                <div class="stat-label">项实用新型</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">13</div>
                <div class="stat-label">项外观专利</div>
              </div>
            </div>
          </div>
        </div>
        <div class="patent-right">
          <img src="../assets/About/About4.png" alt="">
        </div>
      </div>
    </div>
    <div class="culture-section">
      <div class="culture-container">
        <div class="culture-left">
          <div class="culture-title">企业文化</div>
          <div class="culture-item">
            <div class="culture-item-title">使命</div>
            <div class="culture-item-content">不断创新与突破技术，驱动农业生态优势消杀技术发展</div>
          </div>
          <div class="culture-item">
            <div class="culture-item-title">愿景</div>
            <div class="culture-item-content">成为引领全球伴生雾化消杀技术进步的全球化企业</div>
          </div>
          <div class="culture-item">
            <div class="culture-item-title">价值观</div>
            <div class="culture-item-content">价值创造 追求卓越 回报社会 成就你我</div>
          </div>
        </div>
        <div class="culture-right">
          <img src="../assets/About/About4.png" alt="">
        </div>
      </div>
    </div>
    <!--<div class="Aichat">
      <ChatWidget :defaultOpen="isOpen" />
      <div class="Aitext" @click="openChat">AI小曼</div>
    </div>-->
    <Footer />

  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import ConsultSection from '@/components/ConsultSection.vue'
import ProductList from '@/components/ProductList.vue'

export default {
  name: 'Contact',
  components: {
    ConsultSection,
    Footer,
    ProductList
  },
  data() {
    return {
      showMobileMenu: false,
      showProductList: false,
      newsList: [],
      wumanIntro: "",
      teamIntro: "",
      coreTech: "",
      ourPlatform: ""
    }
  },
  created() {
    this.getNewsDetail(643904980070469)
  },
  methods: {
    getNewsDetail(id) {
      // 先获取文章列表
      this.$http.get(`/cms/content/front-list?pageNum=1&pageSize=10&catalogId=${id}`).then(res => {
        if (res.code === 200 && res.data.rows.length > 0) {
          // 存储文章列表
          this.newsList = res.data.rows;

          // 对每篇文章进行详情请求
          this.newsList.forEach(article => {
            this.$http.get(`/cms/content/detail/${id}/article/${article.contentId}`).then(detailRes => {
              if (detailRes.code === 200) {
                // 根据文章标题找到对应的区域并更新内容
                switch (article.title) {
                  case "雾曼简介":
                    this.wumanIntro = detailRes.data.contentHtml;
                    break;
                  case "团队介绍":
                    this.teamIntro = detailRes.data.contentHtml;
                    break;
                  case "核心技术":
                    this.coreTech = detailRes.data.contentHtml;
                    break;
                  case "我们的平台":
                    this.ourPlatform = detailRes.data.contentHtml;
                    break;
                }
              }
            }).catch(error => {
              console.error('获取文章详情失败:', error);
            });
          });
        }
      }).catch(error => {
        console.error('获取文章列表失败:', error);
      });
    },
    handleProductClick() {
      this.showProductList = !this.showProductList;

    },
    FisMobile() {
      this.showProductList = false;
    },
    navigateToConsult() {
      this.$router.push('/contact').then(() => {
        setTimeout(() => {
          window.scrollTo({
            top: 1000,
            behavior: 'smooth'
          });
        }, 500);
      });
    },
    openChat() {
      console.log(this.isOpen)
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>
.page-container {
  background: #F5F6F7;
}

.page-title {
  color: #FFFFFF;
  font-size: 52px;
  font-weight: 500;
  margin: 96px 0 0 213px;
}

.contact-info-section {
  width: 1346px;
  margin: -40px auto 0;
  height: 485px;
  background: #fff;
  border-radius: 15px;
  display: flex;
}

.contact-info-left {
  padding: 30px 23px 23px 30px;
}

.contact-card {
  margin: 0 0 15px 0;
  width: calc(519px - 54px);
  height: 112px;
  background: #F5F6F7;
  border-radius: 7px;
  padding: 27px 22px 0 27px;
}

.contact-card:nth-child(2),
.contact-card:nth-child(3) {
  background: transparent;
}

.contact-card-content {
  display: flex;
}

.icon-wrapper {
  width: 14px;
  height: 20px;
}

.contact-details {
  padding: 0 0 0 16px;
}

.contact-title {
  line-height: 20px;
  font-size: 18px;
  font-weight: 400;
  color: #041214;
}

.contact-address,
.contact-phone {
  font-size: 12px;
  color: #041214;
  font-weight: 400;
  padding: 5px 0 0 0;
}

.map-container {
  padding: 30px 23px 23px 30px;
}

.map-content {
  width: 734px;
  height: 422px;
  background: #000;
}

.consult-section {
  background: #FFFFFF;
  border-radius: 15px;
  width: 1346px;
  margin: 60px auto;
}

@media screen and (max-width: 768px) {
  .page-title {
    font-size: 32px !important;
    margin: 50px 0 0 20px !important;
  }

  .contact-info-section {
    width: 100%;
    margin: -20px auto 0;
    height: auto;
    flex-direction: column;
  }

  .contact-info-left,
  .map-container {
    padding: 15px;
    width: 100%;
  }

  .contact-card {
    width: 100%;
    margin-bottom: 10px;
  }

  .map-content {
    width: 100%;
    height: 300px;
  }

  .consult-section {
    width: 100%;
    margin: 30px auto;
    padding: 15px;
  }

  /* 专利数据展示优化 */
  [style*="display: flex;margin-top: 22px"] {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 15px;
  }

  [style*="margin-right: 50px"] {
    margin-right: 0 !important;
    width: calc(50% - 10px);
    text-align: center;
  }

  [style*="font-size: 32px;color: #E02020"] {
    font-size: 24px !important;
    margin-bottom: 5px;
  }

  [style*="font-size: 16px;color: #000000"] {
    font-size: 14px !important;
  }

  /* 其他通用优化 */
  .page-container {
    overflow-x: hidden;
  }

  .home-container {
    background-position: center;
    background-size: cover;
    height: 200px;
  }

  .info-container {
    padding: 0 15px;
  }

  [style*="padding: 87px 0 70px 0"] {
    padding: 40px 0 35px 0 !important;
  }

  [style*="margin: 73px auto"] {
    margin: 30px auto !important;
  }

  [style*="margin-bottom: 26px"] {
    margin-bottom: 15px !important;
  }

  [style*="background: #F5F6F7"] {
    padding: 15px !important;
  }

  /* 改进交互体验 */
  .mobile-menu-item,
  .consult-button,
  [style*="cursor: pointer"] {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  /* 优化动画性能 */
  * {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
}

.home-container {
  width: 100%;
  height: 380px;
  background-color: #000;
  background-image: url("../assets/About/About1.png");
  background-size: cover;
  background-position: center;
}

.logo-container {
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(3px);
  padding: 0 55px;
  display: flex;
  align-items: center;
  position: relative;
  transition: background-color 0.3s ease;
  z-index: 1001;
}

.logo-wrapper {
  position: absolute;
}

.logo {
  width: 251px;
  height: 32px;
}

.nav-links {
  display: flex;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  text-align: center;
  margin: auto;
  height: 68px;
  line-height: 70px;
  cursor: pointer;
}

.nav-item {
  padding: 0 20px;
}

.nav-item2 {
  border-bottom: 2px solid #FFFFFF;
}

.consult-button {
  background: #FFFFFF;
  border-radius: 17px;
  width: 96px;
  height: 32px;
  font-weight: 600;
  font-size: 14px;
  color: #0A2E43;
  line-height: 32px;
  text-align: center;
  position: absolute;
  right: 54px;
}

/* .info-container {
  width: 1120px;
  margin: auto;
  margin: 233px;
} */

.info-box {
  width: calc(367px - 13px - 13px);
  padding: 0 13px;
  height: 48px;
  background: #FFFFFF;
  border-radius: 8px;
  line-height: 48px;
}

.info-title {
  font-size: 20px;
  color: #041214;
  font-weight: 500;
  font-style: normal;
}

.info-subtitle {
  color: #041214;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
}

.info-text {
  font-weight: 500;
  font-size: 56px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  width: 1120px;
}

.contact-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.contact-label {
  color: #FFFFFF;
  font-size: 14px;
  margin-left: 8px;
}

.contact-button {
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  height: 48px;
  width: 158px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.contact-button img {
  width: 16px;
  height: 16px;
}

.contact-text,
.contact-icon {
  display: none;
}

@media screen and (max-width: 768px) {
  .home-container {
    height: 200px;
  }

  .logo-container {
    padding: 0 15px;
    height: 50px;
  }

  .logo {
    width: 150px;
    height: 20px;
  }

  .nav-links {
    display: none;
  }

  .consult-button {
    display: none;
  }

  .info-container div {
    font-size: 32px !important;
    margin: 50px 0 0 20px !important;
  }

  /* 联系信息区域适配 */
  div[style*="width: 1346px"] {
    width: 100% !important;
    margin: -20px auto 0 !important;
    height: auto !important;
    flex-direction: column;
  }

  div[style*="padding: 30px 23px 23px 30px"] {
    padding: 15px !important;
    width: 100% !important;
  }

  div[style*="width: calc(519px - 54px)"] {
    width: 100% !important;
    margin-bottom: 10px !important;
  }

  /* 地图区域适配 */
  div[style*="width: 734px"] {
    width: 100% !important;
    height: 300px !important;
  }

  /* 咨询区域适配 */
  div[style*="width: 1346px;margin: 60px auto"] {
    width: 100% !important;
    margin: 30px auto !important;
    padding: 15px;
  }
}

.mobile-menu-btn {
  display: none;
  z-index: 1001;
}

@media screen and (max-width: 768px) {
  .mobile-menu-btn {
    display: block;
    position: absolute;
    right: 15px;
    width: 30px;
    height: 25px;
    cursor: pointer;
  }

  .mobile-menu-btn span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #fff;
    margin: 6px 0;
    transition: 0.3s;
  }

  .mobile-menu {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    padding: 70px 0 20px;
    z-index: 1000;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-menu.show {
    display: block;
  }

  .mobile-menu-item {
    color: #fff;
    padding: 15px 20px;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    /* text-align: center; */
  }

  .mobile-menu-item.highlight {
    background: #FFFFFF;
    color: #0A2E43;
    margin: 10px 20px;
    border-radius: 17px;
    height: 40px;
    line-height: 40px;
    padding: 0;
  }
}

/* 当菜单打开时的汉堡按钮动画 */
.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

/* 默认隐藏移动端菜单 */
.mobile-menu {
  display: none;
}

/* 修改媒体查询中的mobile-menu相关样式 */
@media screen and (max-width: 768px) {
  /* ... 其他移动端样式保持不变 ... */

  .mobile-menu {
    display: none;
    /* 默认仍然是隐藏的 */
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: calc(100vh - 50px);
    background: rgba(0, 0, 0, 0.9);
    padding: 0px 0 20px;
    z-index: 1000;
  }

  .mobile-menu.show {
    display: block;
    /* 只有在添加show类时才显示 */
  }

  .mobile-menu-item {
    color: #fff;
    padding: 15px 20px;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    /* text-align: center; */
  }

  .mobile-menu-item.highlight {
    color: #0A2E43;
    background: #fff;
    margin: 10px 15px;
    border-radius: 17px;
    text-align: center;
    border: none;
  }
}

.content-section {
  width: 100%;
  background: #FFFFFF;
}

.content-wrapper {
  width: 1460px;
  margin: auto;
  padding: 73px 0 0 0;
  display: flex;
}

.left-content {
  width: 745px;
}

.section-heading {
  font-size: 40px;
  color: #000000;
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: bold;
  margin-bottom: 26px;
  margin-top: 18px;
}

.intro-text {
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  font-family: SourceHanSansSC, SourceHanSansSC;
  background: #D8D8D835;
  border-radius: 8px;
  padding: 14px 12px 8px 14px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  margin-top: 27px;
}

.red-bar {
  height: 20px;
  width: 5px;
  background: #B80708;
  margin-right: 10px;
}

.header-text {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-family: PingFangSC, PingFang SC;
  line-height: 20px;
}

.team-content,
.tech-content,
.platform-content {
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  font-family: SourceHanSansSC, SourceHanSansSC;
}

.right-content {
  width: 650px;
  height: 784px;
  margin-left: 64px;
}

.right-content img {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .content-wrapper {
    width: 100%;
    flex-direction: column;
    padding: 0 15px;
    margin: 30px auto;
  }

  .left-content {
    width: 100%;
  }

  .section-heading {
    font-size: 28px;
    margin: 15px 0;
  }

  .right-content {
    width: 100%;
    height: auto;
    margin: 20px 0 0 0;
  }
}

/* 专利部分样式 */
.patent-section {
  width: 100%;
  background: #FFFFFF;
  padding: 87px 0 70px 0;
}

.patent-container {
  width: 1460px;
  margin: 0 auto;
  display: flex;
}

.patent-left {
  width: 745px;
  margin-right: 58px;
}

.section-title {
  font-size: 40px;
  font-weight: bold;
  color: #000000;
  line-height: 48px;
}

.patent-box {
  background: #F5F6F7;
  border-radius: 12px;
  padding: 25px 39px 14px 24px;
  margin-top: 24px;
}

.patent-header {
  display: flex;
  align-items: center;
}

.patent-icon {
  width: 24px;
  height: 25px;
  margin-right: 9px;
}

.patent-icon img {
  width: 24px;
  height: 25px;
}

.patent-title {
  font-size: 18px;
  font-weight: bold;
  font-family: SourceHanSansSC, SourceHanSansSC;
  color: #000000;
  line-height: 24px;
}

.patent-content {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 30px;
  margin-top: 14px;
}

.tech-stats {
  margin-top: 37px;
}

.tech-stats-title {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  font-family: SourceHanSansSC, SourceHanSansSC;
}

.stats-container {
  display: flex;
  margin-top: 22px;
}

.stat-item {
  margin-right: 50px;
}

.stat-number {
  font-family: Altinn-DINExp, Altinn-DINExp;
  font-weight: bold;
  font-size: 32px;
  color: #E02020;
  text-align: center;
}

.stat-label {
  font-weight: 400;
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-size: 16px;
  color: #000000;
}

.patent-right img {
  width: 680px;
  height: 401px;
}

/* 企业文化部分样式 */
.culture-section {
  width: 100%;
  background: #FFFFFF;
  padding: 87px 0 70px 0;
}

.culture-container {
  width: 1460px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.culture-title {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
}

.culture-item {
  margin-top: 33px;
}

.culture-item-title {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}

.culture-item-content {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  margin-top: 8px;
}

.culture-right {
  width: 653.82px;
}

.culture-right img {
  width: 653.82px;
  height: 355px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .stat-label {
    text-align: center;
  }

  .patent-container,
  .culture-container {
    width: 100%;
    flex-direction: column;
    padding: 0 15px;
  }

  .patent-left,
  .culture-left {
    width: 100%;
    margin-right: 0;
  }

  .section-title,
  .culture-title {
    font-size: 28px;
  }

  .stats-container {
    flex-wrap: wrap;
    gap: 15px;
  }

  .stat-item {
    width: calc(50% - 10px);
    margin-right: 0;
  }

  .patent-right,
  .culture-right {
    width: 100%;
    margin-top: 20px;
  }

  .patent-right img,
  .culture-right img {
    width: 100%;
    height: auto;
  }

  .patent-section,
  .culture-section {
    padding: 40px 0;
  }
}

.white-bg {
  background: #FFFFFF !important;
}

.nav-item.active-nav {
  color: #E02020;
  border-bottom: 2px solid #E02020;
}

.logo-container {
  transition: background-color 0.3s ease;
}

@media screen and (max-width: 768px) {
  .white-bg {
    background: #FFFFFF !important;
  }

  .mobile-menu-item.active-nav {
    color: #E02020;
  }
}

.nav-links.dark-text .nav-item {
  color: #0A2E43;
}

.nav-links.dark-text .nav-item.active-nav {
  color: #E02020;
}
</style>